export default __webpack_public_path__ + "729dc70a4e6b88027d71fabdaf307475.png";